// extracted by mini-css-extract-plugin
export default {"root":"styles_root__YUwLU","tags":"styles_tags__rkK7j"};